import { useContext, useMemo } from "react";
import { useSelector } from "react-redux";

import { useGetGameAffiliatesQuery } from "@api";
import { MainContext } from "@context";

import { getProviders } from "./utils";

const selectCurrency = (state) => state.balance.currency || undefined;

const useController = ({ history, activeTab }) => {
	const {
		state: { isMobile, isTablet, isDesktop, isWide, isMinor },
	} = useContext(MainContext);

	const currency = useSelector(selectCurrency);

	const isLive = useMemo(() => {
		let currentTab = activeTab?.toLowerCase();

		const tabQueryParam = new URLSearchParams(window.location.search).get("tab");

		if (tabQueryParam) {
			currentTab = tabQueryParam;
		}

		switch (currentTab) {
			case "casino":
				return false;
			case "livecasino":
				return true;
			default:
				return null;
		}
	}, [activeTab]);

	const { data: affiliates } = useGetGameAffiliatesQuery({
		size: 1000,
		isLive: isLive,
		currency: currency,
	});

	const getSlidesPerGroup = () => {
		if (isMinor) {
			return 1;
		} else if (isMobile) {
			return 2;
		} else if (isTablet) {
			return 3;
		} else if (isDesktop) {
			return 4;
		} else if (isWide) {
			return 5;
		} else {
			return 6;
		}
	};

	const filteredAffiliates = (affiliates || [])?.filter((aff) => aff.affiliate !== "egt");

	const allProviders = getProviders();

	const filteredProviders = window.MARS_PROVIDERS
		? allProviders.filter((providerName) =>
				filteredAffiliates?.some(
					(affiliate) => affiliate.affiliate.replace(/[_ ]/g, "") === providerName
				)
			)
		: allProviders.filter((providerName) =>
				filteredAffiliates?.some(
					(affiliate) => affiliate.affiliate.replace(/[_ ]/g, "") === providerName
				)
			) || ["pragmaticplay"];

	const handleSelectProvider = (providerName) => {
		const selectedProvider = filteredAffiliates?.find(
			(item) => item.affiliate.replace(/[_ ]/g, "") === providerName
		);

		console.log(selectedProvider);

		if (selectedProvider)
			history.push(
				"/provider?key=affiliate&name=" +
					selectedProvider.affiliate +
					"&count=" +
					selectedProvider.count
			);
	};

	return {
		state: {
			providers: filteredProviders,
			slidesPerGroup: getSlidesPerGroup(),
		},
		handlers: {
			handleSelectProvider,
		},
	};
};

export default useController;
